import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class AnalogBJTAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normICC = 2;
		this.normVCEO = 30;
		this.normHFEmin = 50;

		this.rankICC = 0;
		this.rankVCEO = 0;
		this.rankHFEmin = 0;

		this.weightICC = 0.15;
		this.weightVCEO = 0.15;
		this.weightHFEmin = 0.2;

		this.rICC = 0;
		this.rVCEO = 0;
		this.rHFEmin = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log(
				'partNumber,' +
					'part_ICC,rICC,rankICC,' +
					'part_VCEO,rVCEO,rankVCEO,' +
					'part_HFEmin,rHFEmin,rankHFEmin,' +
					'feRank'
			);
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);
		// ---------------------------------------------Collector current  IC Cont. (A)---------------------------------------------

		[this.rankICC, this.rICC] = this.calculateRankSingleSliderGTE(
			CIDS.CONTINUES_COLLECTOR_CURRENT,
			product,
			this.normICC
		);

		// ---------------------------------------------Collector-Emitter Breakdown voltage  VCEO Min (V)---------------------------------------------

		[this.rankVCEO, this.rVCEO] = this.calculateRankSingleSliderGTE(
			CIDS.COLLECTOR_EMITTER_VOLTAGE,
			product,
			this.normVCEO
		);

		// ---------------------------------------------Forward current transfer ratio  hFE Min---------------------------------------------

		[this.rankHFEmin, this.rHFEmin] = this.calculateRankSingleSliderGTE(
			CIDS.FORWARD_CURRENT_TRANSFER_RATIO_MIN,
			product,
			this.normHFEmin
		);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightICC * this.rankICC + this.weightVCEO * this.rankVCEO + this.weightHFEmin * this.rankHFEmin;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightICC - this.weightVCEO - this.weightHFEmin) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
